import React, { useEffect } from 'react';
import './PrimusMentorship.css';
import usePageTitle from '../hooks/usePageTitle';
import { useLanguage } from '../hooks/useLanguage';
import borderImage from '../assets/border.png';
import timelineDecoration from '../assets/primus-mentorship-decoration.png';

const PrimusMentorship: React.FC = () => {
  const { t } = useLanguage();
  usePageTitle(t('mentorship.title'));

  useEffect(() => {
    window.scrollTo(0, 0);

    const allElements = document.querySelectorAll('.mentorship-title, .mentorship-description, .progression-title, .phase-section');
    allElements.forEach(element => {
      element.classList.remove('animate-in-initial');
    });

    void document.body.offsetHeight;

    const titleElement = document.querySelector('.mentorship-title');
    if (titleElement) {
      setTimeout(() => {
        titleElement.classList.add('animate-in-initial');
      }, 200);
    }

    const descElement = document.querySelector('.mentorship-description');
    if (descElement) {
      setTimeout(() => {
        descElement.classList.add('animate-in-initial');
      }, 210);
    }

    const progressionTitle = document.querySelector('.progression-title');
    if (progressionTitle) {
      setTimeout(() => {
        progressionTitle.classList.add('animate-in-initial');
      }, 300);
    }

    const phaseSections = document.querySelectorAll('.phase-section');
    phaseSections.forEach((section, index) => {
      setTimeout(() => {
        section.classList.add('animate-in-initial');
      }, 400 + (index * 100));
    });
  }, []);

  const progressionData = [
    {
      phase: t('mentorship.foundation'),
      items: [
        t('mentorship.item1'),
        t('mentorship.item2'),
        t('mentorship.item3'),
        t('mentorship.item4')
      ]
    },
    {
      phase: t('mentorship.formation'),
      items: [
        t('mentorship.item5'),
        t('mentorship.item6'),
        t('mentorship.item7'),
        t('mentorship.item8')
      ]
    },
    {
      phase: t('mentorship.completion'),
      items: [
        t('mentorship.item9'),
        t('mentorship.item10'),
        t('mentorship.item11')
      ]
    }
  ];

  return (
    <div className="mentorship-page">
      <div className="mentorship-hero">
        <div className="mentorship-hero-content">
          <h1 className="mentorship-title">{t('mentorship.title')}</h1>

          <img src={borderImage} alt="" className="mentorship-divider" />

          <p className="mentorship-description">
            {t('mentorship.description')}
          </p>
        </div>
      </div>

      <div className="progression-section-wrapper">
        <div className="progression-section">
          <h2 className="progression-title">{t('mentorship.progressionTitle')}</h2>

          <div className="progression-timeline">
            <img src={timelineDecoration} alt="" className="timeline-decoration" />

            <div className="progression-phases">
              {progressionData.map((phase) => (
                <div key={phase.phase} className="phase-section">
                  <h3 className="phase-title">{phase.phase}</h3>
                  <div className="phase-items">
                    {phase.items.map((item, itemIndex) => (
                      <div key={itemIndex} className="phase-item">
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrimusMentorship;
